import { GroupChannel } from '@sendbird/uikit-react/GroupChannel';
import MessageList from '@sendbird/uikit-react/GroupChannel/components/MessageList';
import { useGroupChannelContext } from '@sendbird/uikit-react/GroupChannel/context';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { useDispatch } from 'react-redux';

import { MODAL_KEYS } from '_constants/modals';
import { resetCurrentMessage, showSearch } from '_store/chat/slice';
import { showModal } from '_store/modals/slice';

import CustomGroupChannelHeader from './CustomGroupChannelHeader';
import CustomMessageContent from './CustomMessageContent';

const CustomGroupChannelView = () => {
  const dispatch = useDispatch();
  const { currentChannel, showSearchIcon } = useGroupChannelContext();

  const handleSearchClick = () => {
    if (isMobile) {
      dispatch(resetCurrentMessage());
      dispatch(showModal({ key: MODAL_KEYS.chatMessageSearch }));
    } else {
      dispatch(showSearch());
    }
  };

  return (
    <GroupChannel
      channelUrl={currentChannel?.url}
      renderChannelHeader={() => (
        <CustomGroupChannelHeader
          currentChannel={currentChannel}
          showSearchIcon={showSearchIcon}
          onSearchClick={handleSearchClick}
        />
      )}
      renderMessageContent={(props) => <CustomMessageContent {...props} />}
      renderMessageList={(props) => <MessageList {...props} />}
    />
  );
};

export default CustomGroupChannelView;
